import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Highlight {
  id: number | string
}

interface HighlightState {
  highlights: Highlight[]
}

const initialState: HighlightState = {
  highlights: [],
}

export const highlightsSlice = createSlice({
  name: 'highlights',
  initialState,
  reducers: {
    setHighlight: (state, { payload }: PayloadAction<Highlight>) => {
      state.highlights = [...state.highlights, payload]
    },
    removeHighlight: (state, { payload }: PayloadAction<Highlight['id']>) => {
      return {
        ...state,
        highlights: state.highlights.filter((item) => item.id !== payload),
      }
    },
  },
})

// Component
export const { setHighlight, removeHighlight } = highlightsSlice.actions

// Store
export const highlightsReducert = highlightsSlice.reducer
